import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

export function SettingsNote() {
  return (
    <Alert className="mb-4">
      <Info className="h-4 w-4" />
      <AlertDescription>
        <strong>Note:</strong> This is a demo view showing sample configurations stored in browser localStorage. 
        In production, all sensitive credentials (SMTP passwords, APNS certificates, ABM tokens) should be stored 
        server-side in the database with proper encryption and RLS policies. Never store real credentials in localStorage 
        as they are vulnerable to XSS attacks and browser-based credential theft.
      </AlertDescription>
    </Alert>
  );
}
